import api from 'api'
import { normalize } from 'normalizr'
import { Schemas } from 'redux-modules/schema'
import { updateEntities, deleteEntity } from 'redux-modules/entity'

const FETCH_REQUEST = 'realhub/providerPriceListItem/FETCH_REQUEST'
const FETCH_SUCCESS = 'realhub/providerPriceListItem/FETCH_SUCCESS'
const FETCH_FAILURE = 'realhub/providerPriceListItem/FETCH_FAILURE'

// Initial State
const initialState = {
  result: [],
  loaded: false,
  loading: false,
  errors: [],
}

// Actions
export function fetchRequest(){
  return {
    type: FETCH_REQUEST,
    loading: true,
  }
}

export function fetchSuccess(payload = {}){
  return {
    type: FETCH_SUCCESS,
    loading: false,
    loaded: true,
    errors: [],
    result: payload && payload.result ? payload.result : null,
  }
}

export function fetchFailure(errors = []){
  return {
    type: FETCH_FAILURE,
    loaded: false,
    loading: false,
    errors,
  }
}

const handleError = errors => errors || ['Something went wrong']

// Action Creators
export function loadAgencyPrice(providerPriceListItemId, options, callback){
  return (dispatch) => {
    dispatch(fetchRequest())

    const promise = api(`/agency/provider_price_list_items/${providerPriceListItemId}/agency_price.json`, options)
      .then(response => (
        response.json().then(json => ({ json, response }))
      ))
      .then(({ json, response }) => {
        if (!response.ok){
          return Promise.reject(json)
        }

        dispatch(fetchSuccess())

        if (callback) callback(json)

        return { success: true, result: json }
      })
      .catch((json) => {
        const errors = json.errors || ['Something went wrong']
        dispatch(fetchFailure(errors))

        return { success: false, result: errors }
      })

    return promise
  }
}

export function buildProviderPriceListItemOptions(providerPriceListItemId, options){
  return (dispatch, getState) => {
    dispatch(fetchRequest())

    // Remove any existing options from redux
    Object.values(getState().entities.providerPriceListItemOptions).forEach((option) => {
      if (option.provider_price_list_item_id === providerPriceListItemId){
        const normalizedOptionJson = normalize(option, Schemas.PROVIDER_PRICE_LIST_ITEM_OPTION)
        dispatch(deleteEntity(normalizedOptionJson))
      }
    })

    const promise = api(`/agency/provider_price_list_items/${providerPriceListItemId}/build_item_options.json`, options)
      .then(response => (
        response.json().then(json => ({ json, response }))
      ))
      .then(({ json, response }) => {
        if (!response.ok){
          return Promise.reject(json)
        }

        const normalizedJson = normalize(json, Schemas.PROVIDER_PRICE_LIST_ITEM)
        dispatch(updateEntities(normalizedJson))
        dispatch(fetchSuccess())

        return { success: true, result: json }
      })
      .catch((json) => {
        const errors = handleError(json)
        dispatch(fetchFailure(errors))

        return { success: false, result: errors }
      })

    return promise
  }
}

// Reducer
export default function reducer(state = initialState, action = {}){
  switch (action.type){
    case FETCH_REQUEST:
      return { ...state, loading: true }
    case FETCH_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        result: action.result || state.result,
        errors: [],
      }
    case FETCH_FAILURE:
      return {
        ...state,
        loading: false,
        loaded: false,
        errors: action.errors,
      }
    default:
      return state
  }
}
